import * as React from 'react'

interface Props {
  render: (el: HTMLElement) => void
}

const ElementRenderer = (props: Props) => {
  const ref = React.useRef<HTMLDivElement>()
  React.useEffect(() => {
    props.render(ref.current)
  }, [])
  return <div className="e-r" ref={ref} />
}

export const elementRendererCreator = (props: Props) => (
  <ElementRenderer {...props} />
)
